<template>
  <div class="onsiteService">
    <template v-if="!isMobile">
      <div class="onsiteService_top">
        <img
          src="https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/PC/CAC/onsiteServiceFacilities_top.png" />
      </div>
      <div class="onsiteService_main">
        <img
          @click="goUrl('https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/mini/cac/2026/%E5%B1%95%E4%BC%9A%E6%9C%8D%E5%8A%A1%E7%82%B9%E4%BD%8D%E7%A4%BA%E6%84%8F%E5%9B%BE%EF%BC%9AExhibition%20Facility%20Layout.jpg')"
          class="pointer" src="@/assets/onsiteService/1.png" />
        <img
          @click="goUrl('https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/mini/cac/2026/%E5%B1%95%E4%BC%9A%E7%8E%B0%E5%9C%BA%E6%9C%8D%E5%8A%A1%E8%81%94%E7%B3%BB%E4%BA%BAOnsite%20Services%20Contact.jpg')"
          class="pointer" src="@/assets/onsiteService/2.png" />
        <img
          @click="goUrl('https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/mini/cac/2026/Transportation%20Guide.jpg')"
          class="pointer" src="@/assets/onsiteService/3.png" />
        <img
          @click="goUrl('https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/mini/cac/2026/%E5%B1%95%E9%A6%86%E2%80%94%E9%85%92%E5%BA%97%E7%8F%AD%E8%BD%A6%E6%97%B6%E5%88%BB%E8%A1%A8Shuttle%20Service%20Schedule.jpg')"
          class="pointer" src="@/assets/onsiteService/4.png" />
        <img
          @click="goUrl('https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/mini/cac/2026/NECC%20Service%20Facilities.jpg')"
          class="pointer" src="@/assets/onsiteService/5.png" />
      </div>
      <div class="onsiteService_main">
        <img
          @click="goUrl('https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/mini/cac/2026/%E5%B1%95%E9%A6%86%E9%A4%90%E9%A5%AE%20Food%20%26%20Restaurants.jpg')"
          class="pointer" src="@/assets/onsiteService/6.png" />
        <img
          @click="goUrl('https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/mini/cac/2026/Exhibitor%20Participation%20Flow.jpg')"
          class="pointer" src="@/assets/onsiteService/7.png" />
        <img
          @click="goUrl('https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/mini/cac/2026/Construction%20%26%20Entry%20Instructions.jpg')"
          class="pointer" src="@/assets/onsiteService/8.png" />
        <img
          @click="goUrl('https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/mini/cac/2026/Exhibition%20Regulations.jpg')"
          class="pointer" src="@/assets/onsiteService/9.png" />
        <img
          @click="goUrl('https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/mini/cac/Exhibitor%20Dismantling%20Arrangements_00.png')"
          class="pointer" src="@/assets/onsiteService/10.png" />
      </div>
      <img class="bg_b" src="@/assets/onsiteService/bg_b.png" />

    </template>
    <template v-else>
      <div class="onsiteService_top_m">
        <img
          src="https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/PC/CAC/onsiteServiceFacilities_top.png" />
      </div>
      <div class="onsiteService_main_m">
        <img
          @click="goUrl('https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/mini/cac/2026/%E5%B1%95%E4%BC%9A%E6%9C%8D%E5%8A%A1%E7%82%B9%E4%BD%8D%E7%A4%BA%E6%84%8F%E5%9B%BE%EF%BC%9AExhibition%20Facility%20Layout.jpg')"
          class="pointer" src="@/assets/onsiteService/1.png" />
        <img
          @click="goUrl('https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/mini/cac/2026/%E5%B1%95%E4%BC%9A%E7%8E%B0%E5%9C%BA%E6%9C%8D%E5%8A%A1%E8%81%94%E7%B3%BB%E4%BA%BAOnsite%20Services%20Contact.jpg')"
          class="pointer" src="@/assets/onsiteService/2.png" />
      </div>
      <div class="onsiteService_main_m">
        <img @click="goUrl('https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/mini/cac/2026/Transportation%20Guide.jpg')" class="pointer" src="@/assets/onsiteService/3.png" />
        <img
          @click="goUrl('https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/mini/cac/2026/%E5%B1%95%E9%A6%86%E2%80%94%E9%85%92%E5%BA%97%E7%8F%AD%E8%BD%A6%E6%97%B6%E5%88%BB%E8%A1%A8Shuttle%20Service%20Schedule.jpg')"
          class="pointer" src="@/assets/onsiteService/4.png" />
      </div>
      <div class="onsiteService_main_m">
        <img
          @click="goUrl('https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/mini/cac/2026/NECC%20Service%20Facilities.jpg')"
          class="pointer" src="@/assets/onsiteService/5.png" />
        <img
          @click="goUrl('https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/mini/cac/2026/%E5%B1%95%E9%A6%86%E9%A4%90%E9%A5%AE%20Food%20%26%20Restaurants.jpg')"
          class="pointer" src="@/assets/onsiteService/6.png" />
      </div>
      <div class="onsiteService_main_m">
        <img
          @click="goUrl('https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/mini/cac/2026/Exhibitor%20Participation%20Flow.jpg')"
          class="pointer" src="@/assets/onsiteService/7.png" />
        <img
          @click="goUrl('https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/mini/cac/2026/Construction%20%26%20Entry%20Instructions.jpg')"
          class="pointer" src="@/assets/onsiteService/8.png" />
      </div>
      <div class="onsiteService_main_m">
        <img
          @click="goUrl('https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/mini/cac/2026/Exhibition%20Regulations.jpg')"
          class="pointer" src="@/assets/onsiteService/9.png" />
        <img
          @click="goUrl('https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/mini/cac/Exhibitor%20Dismantling%20Arrangements_00.png')"
          class="pointer" src="@/assets/onsiteService/10.png" />
      </div>
      <img class="bg_b_m" src="@/assets/onsiteService/bg_b.png" />

    </template>

  </div>
</template>
<script>
export default {
  data() {
    return {
      isMobile : /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
    }
  },

  mounted() {

  },
  methods: {
    goUrl(url) {
      if (url) {
        console.log('url------>', url);
        window.open(this.$router.resolve({
          path: '/onsiteServiceFacilitiesDetail',
          query: {
            url: url
          }
        }).href, '_blank');

        // window.open(url, '_blank')
      }
    },
  }
}
</script>
<style lang="scss" scoped>
.onsiteService{
  background: linear-gradient(90deg, #00B983, #00A6D8);
  margin: auto;
}
.onsiteService_top{
  width: 100%;
  text-align: center;
  margin-top: 60px;
  img{
    width: 531px;
    height:242px;
  }
}
.onsiteService_main{
  width:70%;
  text-align: center;
  margin: 20px auto;
  display: flex;
    justify-content: space-between;
  img{
    width:19%;
  }
}
// .bg_b{
//   margin-top: -80px;
// }

.onsiteService_top_m{
  width: 100%;
  text-align: center;
  margin-top: 40px;
  img{
    width:50%
  }
}
.onsiteService_main_m{
  width: 90%;
    text-align: center;
    margin: 10px auto;
    display: flex;
    justify-content: space-between;
    img {
      width: 48%;
    }
}
.bg_b_m{
  margin-top: 0px;
}
</style>
